import { axios } from '@/utils/request'
const api = {
  Pre: '/admin.php/Sqlversion/pre',
  SqlversionList: '/admin.php/Sqlversion/sqlList',
  AddSql: '/admin.php/Sqlversion/add',
  DelSql: '/admin.php/Sqlversion/del',
  batchSyncDatabase: '/admin.php/Sqlversion/batchSyncDatabase',
  SqlLogList: '/admin.php/Sqlversion/sqlLogList',
  oneSyncDatabase: '/admin.php/Sqlversion/oneSyncDatabase'
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getSqlList (parameter) {
  return axios({
    url: api.SqlversionList,
    method: 'get',
    params: parameter
  })
}

export function addSql (parameter) {
  return axios({
    url: api.AddSql,
    method: 'post',
    data: parameter
  })
}

export function postDeleteSql (params) {
  return axios({
    url: api.DelSql,
    method: 'post',
    data: {
      sql_id: params
    }
  })
}

export function batchSyncDatabase (params) {
  return axios({
    url: api.batchSyncDatabase,
    method: 'post',
    data: params
  })
}

export function oneSyncDatabase (params) {
  return axios({
    url: api.oneSyncDatabase,
    method: 'post',
    data: params
  })
}

export function sqlLogList (parameter) {
  return axios({
    url: api.SqlLogList,
    method: 'get',
    params: parameter
  })
}
